import AppointmentData from './AppointmentData.container';
export default AppointmentData;
